import React from "react";

import { IgTabPanel } from "@intelligems/ig-theme";
import { Grid, Tab, Tabs } from "@mui/material";

import theme from "../../../theme";
import { WidgetsTabWrapper } from "../WidgetsTabWrapper";

import { LibraryTabsProps } from "./types";

export const OfferPersonalizationTabs = ({
  tabValue,
  onChange,
}: LibraryTabsProps) => {
  return (
    <>
      <Grid container direction={"row"} alignItems={"center"} columnSpacing={1}>
        <Grid flex={1} item>
          <Tabs
            centered={true}
            value={tabValue}
            onChange={onChange}
            aria-label={`Campaign Tabs`}
            sx={{
              borderBottom: 1,
              borderColor: theme.palette.gray.light,
              marginBottom: "20px",
            }}
          >
            <Tab sx={{ textTransform: "none" }} label="Quantity Buttons" />
            <Tab sx={{ textTransform: "none" }} label="Progress Bars" />
            <Tab sx={{ textTransform: "none" }} label="Pop Ups" />
            <Tab sx={{ textTransform: "none" }} label="Slide Outs" />
          </Tabs>
        </Grid>
      </Grid>
      <IgTabPanel value={tabValue} index={0}>
        <WidgetsTabWrapper widgetType={"quantityButtons"} />
      </IgTabPanel>
      <IgTabPanel value={tabValue} index={1}>
        <WidgetsTabWrapper widgetType={"discountProgressBar"} />
      </IgTabPanel>
      <IgTabPanel value={tabValue} index={2}>
        <WidgetsTabWrapper widgetType={"messageBoxPopup"} />
      </IgTabPanel>
      <IgTabPanel value={tabValue} index={3}>
        <WidgetsTabWrapper widgetType={"messageBoxSlideOut"} />
      </IgTabPanel>
    </>
  );
};
